import { Chakra } from "@airhelp/react-ui-components";
import PropTypes from "prop-types";

const { Box, SimpleGrid } = Chakra;

const Grid = ({ children, ...props }) => (
  <Box w="full" maxW="1202px" px={4} mb={{ base: 16, md: 32 }} mx="auto" {...props}>
    <SimpleGrid columns={{ base: 1, md: 12 }} spacing={8}>
      {children}
    </SimpleGrid>
  </Box>
);

export default Grid;

Grid.propTypes = {
  children: PropTypes.node,
};

Grid.defaultProps = {
  children: null,
};
